import { css } from 'styled-components';

import { spacing } from '../spacing';

export const root = () => css`
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Myriad', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

export const typography: any = {
  h1: css`
    ${root()}
    font-size: 2rem;
    line-height: 1.06;
    font-weight: bold;
    @media screen and (min-width: ${spacing.breakpoint.md}px) {
      font-size: 2.5rem;
      line-height: 1;
    }
    @media screen and (min-width: ${spacing.breakpoint.lg}px) {
      font-size: 3.125rem;
      line-height: 1;
    }
  `,
  h2: css`
    ${root()}
    font-size: 1.75rem;
    line-height: 1.14;
    font-weight: bold;
    @media screen and (min-width: ${spacing.breakpoint.lg}px) {
      font-size: 2rem;
      line-height: 1.06;
    }
  `,
  h3: css`
    ${root()}
    font-size:  1.5rem;
    line-height: 1.17;
    font-weight: bold;
  `,
  h4: css`
    ${root()}
    font-size: 1.375rem;
    line-height: 1.18;
    font-weight: bold;
    @media screen and (min-width: ${spacing.breakpoint.lg}px) {
      font-size: 1.25rem;
      line-height: 1.3;
    }
  `,
  h5: css`
    ${root()}
    font-size: 1.25rem;
    line-height: 1.2;
    font-weight: 600;
    @media screen and (min-width: ${spacing.breakpoint.lg}px) {
      font-size: 1.125rem;
      line-height: 1.33;
    }
  `,
  h6: css`
    ${root()}
    font-size: 1.125rem;
    line-height: 1.22;
    font-weight: 600;
    @media screen and (min-width: ${spacing.breakpoint.lg}px) {
      font-size: 1rem;
    }
  `,
  textLarge: css`
    ${root()}
    font-size: 1.313rem;
    line-height: 1.43;
    font-weight: normal;
  `,
  textMedium: css`
    ${root()}
    font-size: 1.125rem;
    line-height: 1.56;
    font-weight: normal;
  `,
  textSmall: css`
    ${root()}
    font-size: 1rem;
    line-height: 1.38;
    font-weight: normal;
    @media screen and (min-width: ${spacing.breakpoint.lg}px) {
      font-size: 0.875rem;
      line-height: 1.43;
    }
  `,
  textStandard: css`
    ${root()}
    font-size: 1rem;
    line-height: 1.38;
    font-weight: normal;
  `,
  textXSmall: css`
    ${root()}
    font-size: 1rem;
    line-height: 1.38;
    font-weight: normal;
    @media screen and (min-width: ${spacing.breakpoint.lg}px) {
      font-size: 0.75rem;
      line-height: 1.33;
    }
  `,
  textXXSmall: css`
    ${root()}
    font-size: 1rem;
    line-height: 1.38;
    font-weight: normal;
    @media screen and (min-width: ${spacing.breakpoint.lg}px) {
      font-size: 0.625rem;
      line-height: 1.4;
    }
  `,
};
